<div class="confirmation-dialog">

  <mat-dialog-content>
    <div class="mat-dialog-body">

      <ng-container *ngIf="data.type == 'houseAccount'">
        <div class="img-contianer">
          <img src="./assets/images/icons/checkout/cash-illustration.svg" alt="">
        </div>
        <div class="font-20 fontMedium">
          {{'checkout.Apply House Account payment?' | translate}}
        </div>
        <div class="font-24">
          {{data.currency.currencyCode}} <span class="fontSemiBold">{{data.amount}}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="data.type == 'cash'">
        <div class="img-contianer">
          <img src="./assets/images/icons/checkout/cash-illustration.svg" alt="">
        </div>
        <div class="font-20 fontMedium">
          {{'checkout.Apply cash payment?' | translate}}
        </div>
        <div class="font-24">
          {{data.currency.currencyCode}} <span class="fontSemiBold">{{data.amount}}</span>
        </div>
      </ng-container>


      <ng-container *ngIf="data.type == 'tip'">
        <div class="img-contianer">
          <img src="./assets/images/icons/checkout/tips-illustration.svg" alt="">
        </div>
        <div class="font-20 fontMedium">
          {{'checkout.Remaining (Change)' | translate}}
        </div>
        <div class="font-24">
          {{data.currency.currencyCode}} <span class="fontSemiBold">{{data.amount}}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="data.type == 'done' || data.type == 'doneTakeaway' || data.type == 'doneClient'">
        <div class="img-contianer">
          <ng-lottie [options]="options"></ng-lottie>
        </div>

        <div class="font-20 fontMedium">
          {{'checkout.Transaction successfully done' | translate}}
        </div>

        <div class="font-24 mt-2" *ngIf="data.checkOutResult && data.checkOutResult.orderId && data.type == 'doneClient'">
          {{'checkout.Your Order ID' | translate}} : <span class="fontSemiBold">#{{data.checkOutResult.orderNumber}}</span>
        </div>

        <ng-container *ngIf="(data.type == 'doneTakeaway') && data.amount">
          <div class="font-20 fontMedium grey-color">
            {{'checkout.Remaining (Change)' | translate}}
          </div>
          <div class="font-24">
            {{data.currency.currencyCode}} <span class="fontSemiBold">{{data.amount}}</span>
          </div>
        </ng-container>

      </ng-container>

      <div *ngIf="(data.type == 'doneTakeaway') && false">
        <p class="mt-3 mb-2">{{'placeOrder.Print KDS Order' | translate}}</p>
        <div>
          <ng-container *ngFor="let kitchen of data.checkOutResult?.kitchens">
            <button mat-stroked-button
              [disabled]="loading"
              [class.loading]="loading"
              (click)="callPrinting(kitchen.id)"
              class="btn-gray text-uppercase mx-1">
              <img src="./assets/images/icons/checkout/print-receipt-ic-black.svg" alt="">
              <span>{{kitchen.name}}</span>
            </button>
          </ng-container>
        </div>
      </div>

    </div>
  </mat-dialog-content>


  <mat-dialog-actions>

    <div *ngIf="data.type == 'cash' || data.type == 'houseAccount'">
      <button mat-button type="button" class="btn-grey" (click)="close()">
        {{"forms.Cancel" | translate}}
      </button>
      <button mat-raised-button color="primary" (click)="close(true)"
        [disabled]="loading" [class.loading]="loading">
        {{"checkout.Confirm Payment" | translate}}
      </button>
    </div>

    <div class="d-flex w-100" *ngIf="data.type == 'tip'">
      <button mat-button type="button" class="btn-transparent" (click)="close()">
        {{"checkout.Later" | translate}}
      </button>
      <div class="ml-auto">
        <button mat-button type="button" class="btn-grey" (click)="close('no-tip')">
          {{"checkout.No Tip" | translate}}
        </button>
        <button mat-raised-button color="primary" (click)="close(true)"
          [disabled]="loading" [class.loading]="loading">
          {{"checkout.Add as a Tip" | translate}}
        </button>
      </div>
    </div>

    <div class="pb-3" *ngIf="data.type == 'done' || data.type == 'doneTakeaway'">
      <button mat-button type="button" class="btn-grey" (click)="close()">
        {{"checkout.Ok, Thanks" | translate}}
      </button>

      <button mat-raised-button color="primary"
        *ngIf="data.checkOutResult?.isTotalyPaid && data.checkOutResult?.canPrint"
        (click)="printLoading = true"
        [disabled]="printLoading" [class.loading]="printLoading">
        {{"checkout.Print receipt" | translate}}
      </button>
    </div>

    <div class="pb-3" *ngIf="data.type == 'doneClient'">
      <button mat-button type="button" class="btn-grey" (click)="close()">
        {{"checkout.Ok, Thanks" | translate}}
      </button>
      <a (click)="close()" [routerLink]="['/trackorder']"
        *ngIf="data?.checkOutResult?.orderId"
        [queryParams]="{ id: data.checkOutResult.orderId}" mat-button type="button" color="primary" color="primary">
        {{"orders.Track your order" | translate}}
      </a>
    </div>

  </mat-dialog-actions>
</div>

<div hidden *ngIf="printLoading && data.checkOutResult?.isTotalyPaid">
  <app-receipt
    [orderId]="data.checkOutResult.orderId"
    [checkOutId]="data.checkOutResult.isTotalyPaid ? 0 : data.checkOutResult.checkOutId"
    (isReady)="printLoading = false"
    ></app-receipt>
</div>
